import { CommonModule } from '@angular/common';
import { GoogleMapsModule } from '@angular/google-maps';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from '@app/components/components.module';
import { EaChartsModule } from '@app/dashboard/charts/charts.module';
import { EaAccordionDirective } from '@app/directives/ea-accordion.directive';
import { EaAnalyticEventDirective } from '@app/directives/ea-analytics-event.directive';
import { EaCapitalizeDirective } from '@app/directives/ea-capitalize.directive';
import { EaCarouselDirective } from '@app/directives/ea-carousel.directive';
import { EaCollapseDirective } from '@app/directives/ea-collapse.directive';
import { EaColorizeTextDirective } from '@app/directives/ea-colorize-text.directive';
import { prEnableAfter } from '@app/directives/ea-enable-after.directive';
import { EaNotDotDirective } from '@app/directives/ea-input-with-comma.directive';
import { EaNumericInputDirective } from '@app/directives/ea-numeric-input.directive';
import { EaMinMaxDirective } from '@app/directives/ea-min-max.directive';
import { PrNumericInputDirective } from '@app/directives/pr-numeric-input.directive';
import { EaSwipeDirective } from '@app/directives/ea-swipe.directive';
import { ModalOptimizationModule } from '@app/modals/modal-optimization/modal-optimization.module';
import { ModalAdequacyReviewModule } from '@app/modals/modal-adequacy-review/modal-adequacy-review.module';
import { ModalPasswordModule } from '@app/modals/modal-password/modal-password.module';
import { EaPipesModule } from '@app/pipes/ea-pipes.module';
import { TranslateModule } from '@ngx-translate/core';
// import { IconSpriteModule } from "ng-svg-icon-sprite";
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { frLocale } from 'ngx-bootstrap/locale';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { AutoLocationComponent } from './auto-location/auto-location.component';
import { EaContactCardComponent } from './ea-contact-card/ea-contact-card.component';
import { EaDashCardComponent } from './ea-dash-card/ea-dash-card.component';
import { EaDropdownComponent } from './ea-dropdown/ea-dropdown.component';
import { EaGridkyModule } from './ea-gridky/ea-gridky.module';
import { EaGroupModule } from './ea-group/ea-group.module';
import { EaNewsModule } from './ea-news/ea-news.module';
import { EaNotificationsHeaderComponent } from './ea-notifications-header/ea-notifications-header.component';
import { EaOptimisationsComponent } from './ea-optimisations/ea-optimisations.component';
import { EaParrainageComponent } from './ea-parrainage/ea-parrainage.component';
import { EaPlaceholderComponent } from './ea-placeholder/ea-placeholder.component';
import { EaPopoverConfirmComponent } from './ea-popover-confirm/ea-popover-confirm.component';
import { EaProductSheetComponent } from './ea-product-sheet/ea-product-sheet.component';
import { EaProgressComponent } from './ea-progress/ea-progress.component';
import { EaRadioHeaderComponent } from './ea-radio-header/ea-radio-header.component';
import { EaRadioHeaderDirective } from './ea-radio-header/ea-radio-header.directive';
import { EaSimulationDownloadComponent } from './ea-simulation-download/ea-simulation-download.component';
import { EaSimulationParametersComponent } from './ea-simulation-parameters/ea-simulation-parameters.component';
import { EaTableComponent } from './ea-table/ea-table.component';
import { EaTaxReductionComponent } from './ea-tax-reduction/ea-tax-reduction.component';
import { EaToggleComponent } from './ea-toggle/ea-toggle.component';
import { LoanFormComponent } from './loan-form/loan-form.component';
import { EaRdvCardComponent } from './ea-rdv-card/ea-rdv-card.component';
import { RouterModule } from '@angular/router';
import { AssetHistoryTableComponent } from './asset-history-table/asset-history-table.component';
import { AssetEventsTableComponent } from './asset-events-table/asset-events-table.component';
import { EaDataTableComponent } from './data-table/data-table.component';
import { EaFilterDropdownComponent } from './filter-dropdown/filter-dropdown.component';
import { SimulationOwnerModalComponent } from './simulation-owner-modal/simulation-owner-modal.component';
import { FiscalityRentCeilingsComponent } from './fiscality-rent/fiscality-rent-ceilings.component';
defineLocale('fr', frLocale);

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    EaChartsModule,
    TranslateModule,
    ModalModule.forRoot(),
    CollapseModule.forRoot(),
    BsDatepickerModule.forRoot(),
    ButtonsModule.forRoot(),
    ModalOptimizationModule,
    ModalAdequacyReviewModule,
    ModalPasswordModule,
    AccordionModule.forRoot(),
    PopoverModule.forRoot(),
    // IconSpriteModule,
    EaPipesModule,
    ComponentsModule,
    EaGridkyModule,
    EaNewsModule,
    EaGroupModule,
    GoogleMapsModule,
    RouterModule,
  ],
  exports: [
    FiscalityRentCeilingsComponent,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    ModalModule,
    CollapseModule,
    PopoverModule,
    ButtonsModule,
    BsDatepickerModule,
    EaChartsModule,
    ModalOptimizationModule,
    ModalAdequacyReviewModule,
    ModalPasswordModule,
    AccordionModule,
    // IconSpriteModule,
    RouterModule,
    LoanFormComponent,
    AutoLocationComponent,
    EaToggleComponent,
    EaTaxReductionComponent,
    EaDashCardComponent,
    EaContactCardComponent,
    EaNotificationsHeaderComponent,
    EaDropdownComponent,
    EaPlaceholderComponent,
    EaProgressComponent,
    EaOptimisationsComponent,
    EaTableComponent,
    EaRadioHeaderComponent,
    EaAnalyticEventDirective,
    EaAccordionDirective,
    EaCollapseDirective,
    EaCapitalizeDirective,
    EaCarouselDirective,
    EaColorizeTextDirective,
    EaMinMaxDirective,
    PrNumericInputDirective,
    EaSwipeDirective,
    EaPopoverConfirmComponent,
    prEnableAfter,
    EaProductSheetComponent,
    EaGridkyModule,
    EaParrainageComponent,
    EaNewsModule,
    EaSimulationParametersComponent,
    EaSimulationDownloadComponent,
    EaGroupModule,
    EaNotDotDirective,
    EaNumericInputDirective,
    EaRdvCardComponent,
    AssetHistoryTableComponent,
    AssetEventsTableComponent,
    EaDataTableComponent,
    EaFilterDropdownComponent,
  ],
  declarations: [
    FiscalityRentCeilingsComponent,
    LoanFormComponent,
    SimulationOwnerModalComponent,
    AutoLocationComponent,
    EaToggleComponent,
    EaTaxReductionComponent,
    EaDashCardComponent,
    EaContactCardComponent,
    EaNotificationsHeaderComponent,
    EaDropdownComponent,
    EaPlaceholderComponent,
    EaProgressComponent,
    EaOptimisationsComponent,
    EaTableComponent,
    EaRadioHeaderComponent,
    EaAnalyticEventDirective,
    EaAccordionDirective,
    EaCollapseDirective,
    EaCapitalizeDirective,
    EaCarouselDirective,
    EaColorizeTextDirective,
    EaMinMaxDirective,
    PrNumericInputDirective,
    EaSwipeDirective,
    prEnableAfter,
    EaRadioHeaderDirective,
    EaPopoverConfirmComponent,
    EaProductSheetComponent,
    EaParrainageComponent,
    EaSimulationParametersComponent,
    EaSimulationDownloadComponent,
    EaNotDotDirective,
    EaNumericInputDirective,
    EaRdvCardComponent,
    AssetHistoryTableComponent,
    AssetEventsTableComponent,
    EaDataTableComponent,
    EaFilterDropdownComponent,
  ],
})
export class SharedModule {}
